import React, {
  createContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { experimentConfig } from "../../constants";
import { setTheme } from "../../utils/setTheme";

const {
  TOOL,
  clearControlledStorageForConsent,
  initializeCookiebotConsentBridge,
  isToolAllowed,
  onConsentChange,
} = require("../../../../../shared/cookiebotConsent");

const storageKey = "_soc_experiments";

function assignVariants() {
  if (!isToolAllowed(TOOL.EXPERIMENTS)) {
    clearControlledStorageForConsent();
    return {};
  }

  const variantStatus = JSON.parse(localStorage.getItem(storageKey)) || {};

  for (const experimentName in experimentConfig) {
    // if experiment already exist is discard
    if (experimentName in variantStatus) continue;

    // if experiment is not in localstorage
    const variants = experimentConfig[experimentName];
    variantStatus[experimentName] = {};

    // assign the respective variant
    const totalWeight = Object.values(variants).reduce((a, b) => a + b, 0);
    const roll = Math.random() * totalWeight;

    let acc = 0;
    let assigned = false;
    for (const [variantName, weight] of Object.entries(variants)) {
      acc += weight;
      const result = acc > roll;

      // activate the variant if the result is true or if is already assigned
      variantStatus[experimentName][variantName] = !!(result ^ assigned);
      assigned = result;
    }

    // fallback if the variant is not yet assigned it take and activate the last variant
    if (!assigned) {
      const lastVariant = Object.keys(variants).pop();
      variantStatus[experimentName][lastVariant] = true;
    }
  }

  // remove old experiments
  for (const experimentName in variantStatus) {
    if (!(experimentName in experimentConfig)) {
      delete variantStatus[experimentName];
    }
  }

  localStorage.setItem(storageKey, JSON.stringify(variantStatus));
  return variantStatus;
}

export const getVariantStatus = () => assignVariants();
export const ExperimentContext = createContext({});

const getThemeFromVariant = (variantStatus) => {
  const qaTheme = typeof window !== "undefined" ? window.__qaTheme__ : null;
  if (qaTheme === "default" || qaTheme === "color-style-v2") {
    return qaTheme;
  }

  return "default";
};

export const ExperimentProvider = ({ children }) => {
  // Only assign variants once per mount
  const [variantStatus, setVariantStatus] = useState(() => getVariantStatus());

  useEffect(() => {
    initializeCookiebotConsentBridge();
    return onConsentChange(() => setVariantStatus(getVariantStatus()));
  }, []);

  // Only set theme when variantStatus changes
  useLayoutEffect(() => {
    setTheme({ theme: getThemeFromVariant(variantStatus) });
  }, [variantStatus]);

  return (
    <ExperimentContext.Provider value={variantStatus}>
      {children}
    </ExperimentContext.Provider>
  );
};
